import { notification } from 'antd';
import filter from 'lodash/filter';

export const displayErrors = (nextErrors = [], prevErrors = []) => {
	nextErrors.map((error, index) => {
		if (error && error !== prevErrors[index]) {
			if (process.env.NODE_ENV === 'development') {
				notification.error({
					message: 'Error',
					description: error.message,
				});
			}
		}
		return null;
	});
};

export function getUrlParams(url) {
	if (!url) {
		return {};
	}
	const searchParams = new URLSearchParams(url);
	return Array.from(searchParams.entries()).reduce(
		(allParams, [key, value]) => ({
			...allParams,
			[key]: value,
		}),
		{},
	);
}

export const getFilteredResults = (array = []) => filter(array, (i, index) => index < 5);

export function versionCompare(v1 = '', v2 = '', options) {
	const lexicographical = options && options.lexicographical;
	const zeroExtend = options && options.zeroExtend;
	let v1parts = (v1 || '').split('.');
	let v2parts = (v2 || '').split('.');

	function isValidPart(x) {
		return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
	}

	if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
		return NaN;
	}

	if (zeroExtend) {
		while (v1parts.length < v2parts.length) v1parts.push('0');
		while (v2parts.length < v1parts.length) v2parts.push('0');
	}

	if (!lexicographical) {
		v1parts = v1parts.map(Number);
		v2parts = v2parts.map(Number);
	}
	/* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }] */
	for (let i = 0; i < v1parts.length; ++i) {
		if (v2parts.length === i) {
			return 1;
		}
		if (v1parts[i] === v2parts[i]) {
			/* eslint-disable-next-line */
			continue;
		} else if (v1parts[i] > v2parts[i]) {
			return 1;
		} else {
			return -1;
		}
	}

	if (v1parts.length !== v2parts.length) {
		return -1;
	}

	return 0;
}

export const generatePipelinePayload = ({
	pipelineJSON,
	scriptRefsMap,
	executionContext,
	versionDescription,
	scriptValKey = 'scriptValue',
}) => {
	const formData = new FormData();
	formData.append(
		'pipeline',
		JSON.stringify({
			content: pipelineJSON || '',
			extension: 'json',
			validateContext: executionContext,
		}),
	);
	if (scriptRefsMap) {
		const scriptRefs = Object.keys(scriptRefsMap);
		if (scriptRefs.length) {
			scriptRefs.forEach((ref) => {
				if (scriptRefsMap[ref]) {
					formData.append(
						ref,
						JSON.stringify({
							content: scriptRefsMap[ref][scriptValKey] || '',
							extension: 'js',
						}),
					);
				}
			});
		}
	}
	if (versionDescription) {
		formData.append('versionDescription', versionDescription);
	}
	return formData;
};
